<shared-draggable-dialog-header>
  <h1 class="dialog-title">Insecure SMS with Patient #{{ data.patientId }}</h1>
  <div class="header-actions">
    <button class="btn-link" (click)="hideSystemMessages = !hideSystemMessages">
      {{ hideSystemMessages ? 'Show' : 'Hide' }} system messages
    </button>
    <button class="btn-link" (click)="markAsRead()">Mark as read</button>
  </div>
</shared-draggable-dialog-header>

<div class="dialog-body chat-box">
  @if (isLoading() && messages().length === 0) {
    <div class="loading-state">Loading messages...</div>
  }

  @for (msg of messages(); track msg.id) {
    @if (!shouldHide(msg)) {
      <messaging-message-bubble
        [message]="msg"
        [contentHtml]="(msg | messageContent).html"
        [widgets]="(msg | messageContent).widgets"
        [patientId]="data.patientId"
        [senderType]="getSenderType(msg)"
      />
    }
  }

  @if (!isLoading() && messages().length === 0) {
    <h5 class="empty-state">No conversation history.</h5>
  }
</div>

<div class="sms-warning">
  <span class="chars-left">{{ maxLength - message.length }} characters left</span>
  <div class="alert-message">
    <span>⚠️ you're about to send a SMS message to the patient.</span>
  </div>
</div>

<div class="dialog-footer">
  <form (ngSubmit)="sendMessage()">
    <textarea
      class="form-control"
      [(ngModel)]="message"
      name="message"
      [disabled]="sending()"
      [maxlength]="maxLength"
      placeholder="WARNING - NO PHI."
      rows="2"
    ></textarea>
    <button class="btn btn-success" type="submit" [disabled]="sending() || !message.trim()">Send</button>
  </form>
</div>
